define(function (require) {
    var $ = require("jquery");
    var util = require("@modules/utils");

    function highlightFitbitFormFields() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $("span.field-validation-error:visible").each(function (index, element) {
            $(element).parent("div.form-item").addClass("is-error");
            $(element).parent(".form-item-group").parent().addClass("is-error");
            $(element).parent("div.form-item").find("span.filter-option").addClass("is-error");
            $(element).parent().find("input").attr("aria-labelledby", $(element).attr("id")).attr("aria-invalid", "true");
            $(element).parent().find("div.btn-group").find("select").attr("aria-labelledby", $(element).attr("id")).attr("aria-invalid", "true");
        });
    }

    function undoFitbitFormFieldHighlights() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $("span.field-validation-error").each(function (index, element) {
            $(element).parent("div.form-item").removeClass("is-error");
            $(element).parent(".form-item-group").parent().removeClass("is-error");
            $(element).parent("div.form-item").find("span.filter-option").removeClass("is-error");
            $(element).parent().find("input").attr("aria-labelledby", $(element).parent().parent().find("label").attr("id")).attr("aria-invalid", "false");
            $(element).parent().find("div.btn-group").find("select").attr("aria-labelledby", $(element).parent().parent().find("label").attr("id")).attr("aria-invalid", "false");
        });
    }

    function createValidationSummary() {
        $("div.validation-summary-errors").remove();
        var errorMessages = $("span.field-validation-error:visible")
            .map(function () {
                return $.trim($(this).text());
            })
            .get();

        var valueToRemove = "";

        errorMessages = $.grep(errorMessages, function (value) {
            return value !== valueToRemove;
        });

        var errorMessageCount = $(errorMessages).length;
        var $header = $("header.form-header");
        var listHtml = "";
        $header.before("<div id='javascriptValidationSummary' class='validation-summary-errors form-error-text'>");

        listHtml += "<strong class='form-error-text'>" + errorMessageCount + $(".hidden.validation-error-count").html() + "</strong>";
        listHtml += "<ul>";
        $(errorMessages).each(function (index, element) {
            listHtml += "<li>" + element + "</li>";
        });
        listHtml += "</ul>";
        $(listHtml).appendTo("#javascriptValidationSummary");
    }

    undoFitbitFormFieldHighlights();
    highlightFitbitFormFields();

    $("#fitbitFormStp1Submit").click(function (e) {
        // e.preventDefault();
        undoFitbitFormFieldHighlights();
        $("span.field-validation-error.form-error-hint").hide();

        var firstname = $("#first-name").val();
        var lastname = $("#last-name").val();
        var memberID = $("#memberNumber").val();
        var memberDOB = $("#memberDOB").val();

        var isValid = true;

        if (!firstname) {
            isValid = false;
            $("#FirstNameError").show();
        }

        if (!lastname) {
            isValid = false;
            $("#LastNameError").show();
        }

        if (!memberID) {
            isValid = false;
            $("#MembershipIdError").show();
        }

        if (!memberDOB) {
            isValid = false;
            $("#DateOfBirthError").show();
        }

        if (isValid) {
            undoFitbitFormFieldHighlights();
            $("javascriptValidationSummary").remove();
            $("form#fitbitFormStp1Submit").submit();
        } else {
            e.preventDefault();
            highlightFitbitFormFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    $("#fitbitFormMsamStp1Submit").click(function (e) {
        // e.preventDefault();
        undoFitbitFormFieldHighlights();
        $("span.field-validation-error.form-error-hint").hide();

        var reasonforoverride = $("#reason-for-override").val();

        var isValid = true;

        if (!reasonforoverride) {
            isValid = false;
            $("#ReasonForOverrideError").show();
        }

        if (isValid) {
            undoFitbitFormFieldHighlights();
            $("javascriptValidationSummary").remove();
            $("form#fitbitFormStp1Submit").submit();
        } else {
            e.preventDefault();

            highlightFitbitFormFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    $("#fitbitFormStp2Submit").click(function (e) {
        //e.preventDefault();
        $(this).hide();
        $("#fitbitFormStp2SubmitDisable").show();
        undoFitbitFormFieldHighlights();
        $("span.field-validation-error.form-error-hint").hide();

        var addressLine1 = $("#shipping-address-line1").val();
        var city = $("#shipping-address-city").val();
        var state = $(".filter-option").text();
        var zipCode = $("#shipping-address-zip").val().trim();
        var emailId = $("#email").val();
        var emailMaxLength = $("#email-maxlength").val();
        var fitbitAgreement = $("#fitbit-agreement-chkbox").is(":checked");
        var scanAgreement = $("#scan-fitbit-agreement").is(":checked");

        var isValid = true;

        if (!addressLine1) {
            isValid = false;
            $("#ShippingAddressLine1Error").show();
        }
        if (state == "State") {
            isValid = false;
            $("#StateError").show();
        }
        if (!city) {
            isValid = false;
            $("#CityError").show();
        }

        if (!zipCode) {
            isValid = false;
            $("#ZipCodeError").show();
        }
        //} else if (!util.isValidUSZipCode(zipCode)) {
        //    isValid = false;
        //    $('#ZipCodeInvalid').show();
        //}
        if (!emailId) {
            isValid = false;
            $("#EmailError").show();
        }
        if (!util.isValidEmailLength(emailId, emailMaxLength)) {
            isValid = false;
            $("#emailMaxLengthError").show();
        }

        if (!fitbitAgreement) {
            isValid = false;
            $("#FitbitAgreementError").show();
        }
        if (!scanAgreement) {
            isValid = false;
            $("#ScanAgreementError").show();
        }

        if (isValid) {
            undoFitbitFormFieldHighlights();
            $("javascriptValidationSummary").remove();
            $("form#fitbitFormStp2Submit").submit();
        } else {
            e.preventDefault();
            $(this).show();
            $("#fitbitFormStp2SubmitDisable").hide();
            highlightFitbitFormFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });
    $("#fitbitFormMsamOverride").click(function (e) {
        $(this).hide();
        $(".override-form").show();
    });
});
